export enum ViewType {
  CARD = 'card',
  TABLE = 'table',
}
